import type { FunctionComponent } from 'react'

import type { LaptopHelperState } from '../Navigation/LaptopHelperNavigation'
import { ExampleStep1 } from './ExampleStep1/ExampleStep1'
import { ExampleStep2 } from './ExampleStep2/ExampleStep2'

export type LaptopHelperStepProps = {
  laptopHelperState: LaptopHelperState
  onUpdate: (newState: Partial<LaptopHelperState>) => void
}

export type LaptopHelperStep = {
  component: FunctionComponent<LaptopHelperStepProps>
  title?: string
}

export const Steps: LaptopHelperStep[] = [
  {
    component: ExampleStep1,
  },
  { component: ExampleStep2 },
]
